import { render, staticRenderFns } from "./SelectSparepartRequestStatus.vue?vue&type=template&id=2122f718&"
import script from "./SelectSparepartRequestStatus.vue?vue&type=script&lang=ts&"
export * from "./SelectSparepartRequestStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2122f718')) {
      api.createRecord('2122f718', component.options)
    } else {
      api.reload('2122f718', component.options)
    }
    module.hot.accept("./SelectSparepartRequestStatus.vue?vue&type=template&id=2122f718&", function () {
      api.rerender('2122f718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectSparepartRequestStatus.vue"
export default component.exports